/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { ThreadModel } from '../../models';
import { ThreadAction } from '../actions';

export interface ThreadState {
  threadEntityState?: EntityState<ThreadModel>;
  loadedResourceTypes?: { [resourceType: string]: boolean };
  areAllLoaded?: boolean;
  areAllLoading?: boolean;
}

function selectThreadId(thread: ThreadModel): string {
  return thread.id;
}

const threadAdapter: EntityAdapter<ThreadModel> = createEntityAdapter<ThreadModel>({
  selectId: selectThreadId,
});

const initialState: ThreadState = {
  threadEntityState: threadAdapter.getInitialState(),
  loadedResourceTypes: {},
  areAllLoaded: false,
};

const adapterReducer = createReducer(
  initialState,
  on(ThreadAction.LoadAll, (state) => ({
    ...state,
    areAllLoading: true,
  })),
  on(ThreadAction.AllLoaded, (state, action) => {
    return {
      ...state,
      loadedResourceTypes: getResourceTypeIndex(action.threads),
      threadEntityState: threadAdapter.addMany(action.threads, threadAdapter.removeAll(state.threadEntityState)),
      areAllLoaded: true,
      areAllLoading: false,
    };
  }),
  on(ThreadAction.Created, (state, action) => {
    return {
      ...state,
      threadEntityState: threadAdapter.addOne(action.thread, state.threadEntityState),
    };
  }),
  on(ThreadAction.Updated, (state, action) => {
    return {
      ...state,
      threadEntityState: threadAdapter.updateMany(
        action.updatedThreads.map((updatedThread) => ({ id: selectThreadId(updatedThread), changes: updatedThread })),
        state.threadEntityState,
      ),
    };
  }),
  on(ThreadAction.UpdateFailed, (state, action) => {
    return {
      ...state,
      threadEntityState: threadAdapter.updateMany(
        action.threadsBeforeUpdate.map((updatedThread) => ({
          id: selectThreadId(updatedThread),
          changes: updatedThread,
        })),
        state.threadEntityState,
      ),
    };
  }),
  on(ThreadAction.Deleted, (state, action) => {
    return {
      ...state,
      threadEntityState: threadAdapter.removeMany(
        action.deletedThreads.map((thread) => selectThreadId(thread)),
        state.threadEntityState,
      ),
    };
  }),
  on(ThreadAction.DeleteFailed, (state, action) => {
    return {
      ...state,
      threadEntityState: threadAdapter.addMany(action.deletedThreads, state.threadEntityState),
    };
  }),
);

export const threadReducer = (state = initialState, action: Action) => adapterReducer(state, action);

function getResourceTypeIndex(threads: ThreadModel[]): {
  [resourceType: string]: true;
} {
  return threads
    .filter((thread) => thread.resourceType)
    .reduce((result, thread) => ({ ...result, [thread.resourceType]: true }), {});
}
